import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/appointment/mutations'
import { path } from '@/store/appointment/types'
import { mutation } from '@/utils/mutation'
import state, { IAppointmentState } from '@/store/appointment/state'

export * from '@/store/appointment/state'

export const store: Module<IAppointmentState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
